export const languages = [
  { value: 'en-us', label: 'English' },
  { value: 'zh-cn', label: 'Chinese Simplified' },
  { value: 'zh-tw', label: 'Chinese Traditional' },
  { value: 'fr-ca', label: 'Canadian French' },
  { value: 'es', label: 'Spanish (Latin America)' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ar-sa', label: 'Arabic' },
  { value: 'nl', label: 'Dutch' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'pt-br', label: 'Portuguese (Brazil)' },
  { value: 'ru', label: 'Russian' },
  { value: 'th', label: 'Thai' },
  { value: 'vi', label: 'Vietlabelse' },
  { value: 'it', label: 'Italian' },
  { value: 'pl', label: 'Polish' },
];
